import { update } from 'draft-js/lib/DefaultDraftBlockRenderMap'
import { takeEvery, takeLatest, call } from 'redux-saga/effects'

import {
  createBoard,
  createCourse,
  createEnrolment,
  createStandard,
  createSubject,
  createSubjectCategory,
  createDemoClassBooking,
  deleteBoard,
  deleteCourse,
  deleteEnrolment,
  deleteTrialSessions,
  deleteStandard,
  deleteSubject,
  deleteSubjectCategory,
  fetchBoard,
  fetchCourse,
  fetchTrialSessions,
  fetchEnrolment,
  fetchAttendance,
  fetchStandard,
  fetchSubject,
  fetchSubjectCategory,
  fetchBatch,
  deleteBatch,
  fetchInventorySchedules,
  fetchSchoolAttendance,
  updateBatch,
  updateBoard,
  updateCourse,
  updateTrialSessions,
  updateEnrolment,
  updateStandard,
  updateSubject,
  updateSubjectCategory,
  updateAttendance,
  createTrialSessions,
  fetchmakeUp,
  createClassBooking,
  fetchDemoSchedule,
  programEnrolment,
  fetchExploreSessionEnrolments,
  fetchExploreEnrolment,
  fetchExcelEnrolment,
  fetchPsAcEnrolment,
  fetchPlaydateSubject,
  createPlaydateSubject,
  updatePlaydateSubject,
  fetchToddlerClubEnrolment,
  fetchToddlerClubSession,
  fetchToddlerClubSubject,
  createToddlerClubSubject,
  updateToddlerClubSubject
} from 'api'
import constants from 'app/constants'
import { eventEmitter, eventAlert } from 'app/helpers'
import {
  fetchBoardData,
  fetchBoardDataSuccess,
  fetchCourseData,
  fetchCourseDataSuccess,
  fetchTrialSessionsData,
  fetchTrialSessionsDataSuccess,
  fetchEnrolmentData,
  fetchEnrolmentDataSuccess,
  fetchMakeUpSessionData,
  fetchMakeUpSessionDataSuccess,
  fetchStandardData,
  fetchStandardDataSuccess,
  fetchSubjectCategoryData,
  fetchSubjectCategoryDataSuccess,
  fetchSubjectData,
  fetchSubjectDataSuccess,
  fetchBatchData,
  fetchBatchDataSuccess,
  fetchSchoolAttendanceData,
  fetchSchoolAttendanceDataSuccess,
  fetchInventorySchedulesData,
  fetchInventorySchedulesDataSuccess,
  updateClassDataSuccess,
  fetchScheduleSessionActivityData,
  fetchScheduleSessionActivityDataSuccess,
  fetchExploreSessionDataSuccess,
  fetchExploreSessionData,
  fetchExploreEnrolmentData,
  fetchExploreEnrolmentDataSuccess,
  fetchExcelEnrolmentData,
  fetchExcelEnrolmentDataSuccess,
  fetchPsAcEnrolmentData,
  fetchPsAcEnrolmentDataSuccess,
  fetchPlaydateSubjectData,
  fetchPlaydateSubjectDataSuccess,
  fetchToddlerClubEnrolmentData,
  fetchToddlerClubEnrolmentDataSuccess,
  fetchToddlerClubSessionData,
  fetchToddlerClubSessionDataSuccess,
  fetchToddlerClubSubjectData,
  fetchToddlerClubSubjectDataSuccess
} from 'app/store/actions/classEntity'
import * as types from 'app/store/types/classEntity'

import { handleFetch, handleUpdate } from './saga.helper'

const mapping = {
  [constants.SUBJECT_CATEGORY]: {
    api: {
      fetch: fetchSubjectCategory,
      create: createSubjectCategory,
      update: updateSubjectCategory,
      delete: deleteSubjectCategory
    },
    action: {
      fetch: fetchSubjectCategoryData,
      fetchSuccess: fetchSubjectCategoryDataSuccess
    }
  },
  [constants.SUBJECT]: {
    api: {
      fetch: fetchSubject,
      create: createSubject,
      update: updateSubject,
      delete: deleteSubject
    },
    action: {
      fetch: fetchSubjectData,
      fetchSuccess: fetchSubjectDataSuccess
    }
  },
  [constants.PLAY_DATE_SUBJECT]: {
    api: {
      fetch: fetchPlaydateSubject,
      create: createPlaydateSubject,
      update: updatePlaydateSubject,
      delete: deleteSubject
    },
    action: {
      fetch: fetchPlaydateSubjectData,
      fetchSuccess: fetchPlaydateSubjectDataSuccess
    }
  },
  [constants.STANDARD]: {
    api: {
      fetch: fetchStandard,
      create: createStandard,
      update: updateStandard,
      delete: deleteStandard
    },
    action: {
      fetch: fetchStandardData,
      fetchSuccess: fetchStandardDataSuccess
    }
  },
  [constants.BOARD]: {
    api: {
      fetch: fetchBoard,
      create: createBoard,
      update: updateBoard,
      delete: deleteBoard
    },
    action: {
      fetch: fetchBoardData,
      fetchSuccess: fetchBoardDataSuccess
    }
  },
  [constants.COURSE]: {
    api: {
      fetch: fetchCourse,
      create: createCourse,
      update: updateCourse,
      delete: deleteCourse
    },
    action: {
      fetch: fetchCourseData,
      fetchSuccess: fetchCourseDataSuccess
    }
  },
  [constants.TRIAL_SESSIONS]: {
    api: {
      fetch: fetchTrialSessions,
      create: createTrialSessions,
      update: updateTrialSessions,
      delete: deleteTrialSessions
    },
    action: {
      fetch: fetchTrialSessionsData,
      fetchSuccess: fetchTrialSessionsDataSuccess
    }
  },
  [constants.ENROLMENT]: {
    api: {
      fetch: fetchEnrolment,
      create: createEnrolment,
      update: updateEnrolment,
      delete: deleteEnrolment
    },
    action: {
      fetch: fetchEnrolmentData,
      fetchSuccess: fetchEnrolmentDataSuccess
    }
  },
  [constants.MAKE_UP_SESSION]: {
    api: { fetch: fetchmakeUp },
    action: {
      fetch: fetchMakeUpSessionData,
      fetchSuccess: fetchMakeUpSessionDataSuccess
    }
  },
  [constants.EXPLORE_SESSION]: {
    api: { fetch: fetchExploreSessionEnrolments },
    action: {
      fetch: fetchExploreSessionData,
      fetchSuccess: fetchExploreSessionDataSuccess
    }
  },
  [constants.EXPLORE_ENROLMENT]: {
    api: {
      fetch: fetchExploreEnrolment
    },
    action: {
      fetch: fetchExploreEnrolmentData,
      fetchSuccess: fetchExploreEnrolmentDataSuccess
    }
  },
  [constants.EXCEL_ENROLMENT]: {
    api: { fetch: fetchExcelEnrolment },
    action: {
      fetch: fetchExcelEnrolmentData,
      fetchSuccess: fetchExcelEnrolmentDataSuccess
    }
  },
  [constants.PSAC_ENROLMENT]: {
    api: { fetch: fetchPsAcEnrolment },
    action: {
      fetch: fetchPsAcEnrolmentData,
      fetchSuccess: fetchPsAcEnrolmentDataSuccess
    }
  },
  [constants.BATCH]: {
    api: {
      fetch: fetchBatch,
      update: updateBatch,
      delete: deleteBatch
    },
    action: {
      fetch: fetchBatchData,
      fetchSuccess: fetchBatchDataSuccess
    }
  },
  [constants.SCHOOL_ATTENDANCE]: {
    api: {
      fetch: fetchSchoolAttendance,
      update: updateAttendance
    },
    action: {
      fetch: fetchSchoolAttendanceData,
      fetchSuccess: fetchSchoolAttendanceDataSuccess
    }
  },
  [constants.INVENTORY_SCHEDULES]: {
    api: {
      fetch: fetchInventorySchedules
    },
    action: {
      fetch: fetchInventorySchedulesData,
      fetchSuccess: fetchInventorySchedulesDataSuccess
    }
  },
  [constants.SCHEDULE_SESSION_ACTIVITY]: {
    api: {
      fetch: fetchDemoSchedule
    },
    action: {
      fetch: fetchScheduleSessionActivityData,
      fetchSuccess: fetchScheduleSessionActivityDataSuccess
    }
  },
  [constants.TODDLER_CLUB_ENROLMENT]: {
    api: {
      fetch: fetchToddlerClubEnrolment
    },
    action: {
      fetch: fetchToddlerClubEnrolmentData,
      fetchSuccess: fetchToddlerClubEnrolmentDataSuccess
    }
  },
  [constants.TODDLER_CLUB_SESSION]: {
    api: {
      fetch: fetchToddlerClubSession
    },
    action: {
      fetch: fetchToddlerClubSessionData,
      fetchSuccess: fetchToddlerClubSessionDataSuccess
    }
  },
  [constants.TODDLER_CLUB_SUBJECT]: {
    api: {
      fetch: fetchToddlerClubSubject,
      create: createToddlerClubSubject,
      update: updateToddlerClubSubject,
      delete: deleteSubject
    },
    action: {
      fetch: fetchToddlerClubSubjectData,
      fetchSuccess: fetchToddlerClubSubjectDataSuccess
    }
  }
}

export function* _fetchClassEntity({ queries, entity } = {}) {
  const mappingData = mapping[entity]
  yield handleFetch(mappingData, queries, entity)
}

export function* _updateClassEntity({ entity, event, value } = {}) {
  const mappingData = mapping[entity]
  yield handleUpdate(mappingData, entity, event, value, updateClassDataSuccess)
}

export function* watchFetchClassEntity() {
  yield takeLatest(
    [
      types.FETCH_SUBJECT_CATEGORY_DATA,
      types.FETCH_SUBJECT_DATA,
      types.FETCH_STANDARD_DATA,
      types.FETCH_BOARD_DATA,
      types.FETCH_COURSE_DATA,
      types.FETCH_BATCH_DATA,
      types.FETCH_TRIAL_SESSIONS_DATA,
      types.FETCH_ENROLMENT_DATA,
      types.FETCH_SCHOOL_ATTENDANCE_DATA,
      types.FETCH_INVENTORY_SCHEDULES_DATA,
      types.FETCH_MAKE_UP_SESSION_DATA,
      types.FETCH_SCHEDULE_SESSION_ACTIVITY_DATA,
      types.FETCH_EXPLORE_SESSION_DATA,
      types.FETCH_EXPLORE_ENROLMENT_DATA,
      types.FETCH_EXCEL_ENROLMENT_DATA,
      types.FETCH_PSAC_ENROLMENT_DATA,
      types.FETCH_PLAYDATE_SUBJECT_DATA,
      types.FETCH_TODDLER_CLUB_ENROLMENT_DATA,
      types.FETCH_TODDLER_CLUB_SESSION_DATA,
      types.FETCH_TODDLER_CLUB_SUBJECT_DATA
    ],
    _fetchClassEntity
  )
}

export function* watchUpdateClassEntity() {
  yield takeEvery(types.UPDATE_CLASS_DATA, _updateClassEntity)
}

export function* _watchCreateDemoClassBooking({ value } = {}) {
  try {
    const response = yield call(createDemoClassBooking, value)
    if (response.success) {
      eventEmitter.emit(constants.INVENTORY_BOOKING_SUCCESS)
      eventAlert('Successfully Booked!', constants.SUCCESS)
    }
  } catch (error) {
    console.log('error in demo class booking :- ', error)
    eventEmitter.emit(constants.INVENTORY_BOOKING_ERROR)
    eventAlert(error.message, constants.ERROR)
  }
}

export function* watchCreateDemoClassBooking() {
  yield takeEvery(types.CREATE_DEMO_CLASS_BOOKING, _watchCreateDemoClassBooking)
}

export function* _watchCreateClassBooking({ value } = {}) {
  try {
    const response = yield call(createClassBooking, value)
    if (response.success) {
      eventEmitter.emit(constants.INVENTORY_BOOKING_SUCCESS)
      eventAlert('Successfully Booked!', constants.SUCCESS)
    }
  } catch (error) {
    console.log('error in class booking :- ', error)
    eventEmitter.emit(constants.INVENTORY_BOOKING_ERROR)
    eventAlert(error.message, constants.ERROR)
  }
}

export function* watchCreateClassBooking() {
  yield takeEvery(types.CREATE_CLASS_BOOKING, _watchCreateClassBooking)
}

export function* _watchCreateExcelBooking({ value } = {}) {
  try {
    const response = yield call(programEnrolment, value)
    if (response.success || response?.program) {
      eventEmitter.emit(constants.INVENTORY_BOOKING_SUCCESS)
      eventAlert('Successfully Booked!', constants.SUCCESS)
    }
  } catch (error) {
    console.log('error in class booking :- ', error)
    eventEmitter.emit(constants.INVENTORY_BOOKING_ERROR)
    eventAlert(error.message, constants.ERROR)
  }
}

export function* watchCreateExcelBooking() {
  yield takeEvery(types.CREATE_EXCEL_BOOKING, _watchCreateExcelBooking)
}
